<template>
  <router-view />
</template>

<script>

export default {
  name: 'ComponentWrap'

}
</script>

<style lang="scss" scoped>

</style>
